export default __webpack_public_path__ + "static/media/01bg_icon.d0a97c77.png";